import { create } from "zustand";

// UI-only state: no graph data, coordinates, or render-loop subscriptions.
export const useNodeLabelStore = create<{
  hoveredId: string | null;
  hover: (id: string | null) => void;
}>((set, get) => ({
  hoveredId: null,
  hover: (id) => {
    if (get().hoveredId !== id) set({ hoveredId: id });
  },
}));
